var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["job-vita--grid-area", { "has-title": _vm.area.title }] },
    [
      _vm.area.title
        ? _c(
            "div",
            { staticClass: "job-vita--grid-area-title" },
            [
              _vm._v("\n\t\t" + _vm._s(_vm.area.title) + "\n\t\t"),
              _vm.area.subTitle
                ? [_c("br"), _vm._v(_vm._s(_vm.area.subTitle))]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.area.predefinedValue
        ? _c(
            "div",
            { staticClass: "job-vita--grid-area-predefined-value" },
            [
              _c("PredefinedValue", {
                attrs: { "predefined-value": _vm.area.predefinedValue }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.area.needsUpgrade
        ? _c(
            "div",
            { staticClass: "job-vita--grid-area-needs-upgrade" },
            [
              _c("Button", {
                attrs: { text: "Details", secondary: "", smaller: "" },
                on: {
                  click: function($event) {
                    _vm.showUpgradePopUp = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "job-vita--grid-area-sections" },
        _vm._l(_vm.area.sections, function(section) {
          return _c("Section", {
            key: section.id,
            attrs: {
              section: section,
              "job-profile-id": _vm.jobProfileId,
              "pseudonym-id": _vm.pseudonymId
            },
            on: { upgrade: _vm.onUpgrade }
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.showUpgradePopUp
        ? _c("UpgradePopUp", {
            attrs: {
              "job-profile-id": _vm.jobProfileId,
              "pseudonym-id": _vm.pseudonymId
            },
            on: {
              upgrade: _vm.onUpgrade,
              hidden: function($event) {
                _vm.showUpgradePopUp = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }